import React from 'react'
import { useSelector } from 'react-redux'
import { Field, formValueSelector } from 'redux-form'

import DynamicInput from '../../../../Shared/Forms/DynamicInput'
import WrappedInput from '../../../../Shared/Forms/WrappedInput'
import { FORM_NAME } from './Form'

const AUTH_TYPES = [
  { label: 'None', value: '' },
  { label: 'Basic Auth', value: 'basic' },
  { label: 'Bearer', value: 'bearer' },
]

export default function Auth({ action, stepId }) {
  const selector = formValueSelector(FORM_NAME)
  const type = useSelector(state => selector(state, 'auth.type'))

  return (
    <div>
      <Field
        name="auth.type"
        label="Type"
        options={AUTH_TYPES}
        component={WrappedInput}
      />
      {type === 'basic' && (
        <>
          <Field
            name="auth.username"
            component={DynamicInput}
            actionId={action.id}
            stepId={stepId}
            label="Username"
          />
          <Field
            name="auth.password"
            component={DynamicInput}
            actionId={action.id}
            stepId={stepId}
            label="Password"
          />
        </>
      )}
      {type === 'bearer' && (
        <Field
          name="auth.token"
          component={DynamicInput}
          actionId={action.id}
          stepId={stepId}
          label="Token"
        />
      )}
    </div>
  )
}
